module.exports = __webpack_public_path__ + "src/assets/fonts/Roboto-Bold.ttf";